import React from 'react';
import { VideoPlayerBox } from '../element';
import { VideoPlayer } from '../video';

const VideoBox = (props) => {
  return (
    <VideoPlayerBox>
      <VideoPlayer url={props.videoUrl} id={props.id} />
    </VideoPlayerBox>
  );
};

export default VideoBox;
